
//importaciones de componentes
import { Button, Checkbox, Divider, FormControl, FormControlLabel, Grid, TextField } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

export const ModalGPSRenewal = ({useFetchInit}) =>{

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,

        defaultData,
        
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { modalOpeningMode} = globalStates

    // ------------------------------------------------ actions
    const { 
        handleClickCloseModal, 
        handleChangeTotalGPS, 
        handleChangeCheckCuotasGPS,
        onSubmitFormGPSRenewal,

    } = Actions

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormGPSRenewal:{formState, onInputChange, onInputChangeForNumber,onInputChangeForCheckBox} } = Forms
    

    return(
        <>
            <form onSubmit={onSubmitFormGPSRenewal}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 5 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="fecha_ren_gps">Fecha de renovacion de GPS</label>
                            <TextField
                                id='fecha_ren_gps'
                                name='fecha_ren_gps'
                                value={ formState.fecha_ren_gps }
                                onChange={ onInputChange }
                                size='small'
                                hiddenLabel
                                type='date'
                                variant='filled'
                                InputProps={{
                                    readOnly: true
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth> 
                            <label htmlFor="gps">Cuota actual de GPS</label>
                            <TextField
                                id='gps'
                                name='gps'
                                value={ formState.gps }
                                onChange={ onInputChange }
                                size='small'
                                placeholder='gps'
                                hiddenLabel
                                type='text'
                                variant='filled'
                                InputProps={{
                                    readOnly: true
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth> 
                            <label htmlFor="cuotas_restantes">Cuotas restantes del credito</label>
                            <TextField
                                id='cuotas_restantes'
                                name='cuotas_restantes'
                                value={ formState.cuotas_restantes }
                                onChange={ onInputChange }
                                size='small'
                                placeholder='cuotas restantes'
                                hiddenLabel
                                type='text'
                                variant='filled'
                                InputProps={{
                                    readOnly: true
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="total_gps">* Total del nuevo GPS (Q) </label>
                            <TextField
                                id='total_gps'
                                name='total_gps'
                                size='small'
                                type='text'
                                placeholder='0'
                                hiddenLabel
                                value={ formState.total_gps }
                                onChange={ handleChangeTotalGPS }
                                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                InputProps={{
                                    readOnly: (modalOpeningMode === 'READONLY') ? true : false
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="cuota_nuevo_gps">* Nueva cuota de GPS (Q)</label>
                            <TextField
                                id='cuota_nuevo_gps'
                                name='cuota_nuevo_gps'
                                size='small'
                                type='text'
                                placeholder='0'
                                hiddenLabel
                                value={ formState.cuota_nuevo_gps }
                                onChange={ onInputChange }
                                variant='filled'
                                InputProps={{
                                    readOnly: true
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 12, lg: 12 }} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                                name='check_cuotas'
                                value={formState.check_cuotas}
                                onChange={handleChangeCheckCuotasGPS}
                            />
                          }
                          label="Distribuir pago en cuotas restantes"    
                        />
                    </Grid> 
                </Grid>

                <div className="border-bottom border-secondary "></div>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '10%' }}>                
                    <Grid item xs={12}>
                        <div className="text-center">
                            <Button 
                                startIcon={<ArrowLeftCircle/>}
                                variant="contained"
                                type="button" 
                                className='btn-round'
                                color='warning'
                                onClick={() => handleClickCloseModal(false, 'EDIT')} 
                                sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
                            >
                                Volver
                            </Button>

                            {(modalOpeningMode==='EDITABLE') && (
                                <Button
                                    endIcon={<ArrowRightCircle/>}
                                    variant="contained"
                                    type="submit"
                                    className='btn-round'
                                    color='primary'
                                    sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
                                >
                                    Guardar
                                </Button>
                            )}
                        </div>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}
